import gql from 'graphql-tag';

import { getSingleProp } from 'src/lib/graphql';
import { executeGqlMutation } from 'src/graphql/client';

const MUTATION = gql`
  mutation RunMultiPromptRunnerAsync(
    $chainId: ID!
    $csvChainId: ID
    $blocksUpdatedSettings: JSON!
    $removedBlocks: [ID!]
  ) {
    runMultiPromptRunnerAsync(
      chainId: $chainId
      csvChainId: $csvChainId
      blocksUpdatedSettings: $blocksUpdatedSettings
      removedBlocks: $removedBlocks
    ) {
      chainId
      csvChainId
    }
  }
`;

export const runMultiPromptRunnerAsync = async ({
  chainId,
  csvChainId,
  blocksUpdatedSettings,
  removedBlocks,
}) => {
  const variables = {
    chainId,
    csvChainId,
    blocksUpdatedSettings,
    removedBlocks,
  };

  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp(response.data);
};
